import { Typography, TypographyProps, useTheme } from "@mui/material";
import { Iconify } from "..";

interface ChangeTextProps extends TypographyProps {
  value: number;
}

export const ChangeText = ({ value, children, ...props }: ChangeTextProps) => {
  const theme = useTheme();
  return (
    <Typography
      fontWeight="inherit"
      fontSize="inherit"
      color={
        value > 0
          ? theme.palette.success.dark
          : value === 0
          ? theme.palette.text.primary
          : theme.palette.error.light
      }
      display="flex"
      alignItems="center"
      gap={1}
      {...props}
    >
      <Iconify
        icon={
          value > 0
            ? "tabler:caret-up-filled"
            : value === 0
            ? "tabler:caret-right-filled"
            : "tabler:caret-down-filled"
        }
      />
      {children ?? value}
    </Typography>
  );
};
